var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _path31, _g31, _path32, _g32, _path33, _g33, _path34, _g34, _path35, _g35, _path36, _g36, _path37, _g37, _path38, _g38, _path39, _g39, _path40, _g40, _path41, _g41, _path42, _g42, _path43, _g43, _path44, _g44, _path45, _g45, _path46, _g46, _path47, _g47, _path48, _g48, _path49, _g49, _path50, _g50, _path51, _g51, _path52, _g52, _path53, _g53, _path54, _g54, _path55, _g55, _path56, _g56, _path57, _g57, _path58, _g58, _path59, _g59, _path60, _g60, _path61, _g61, _path62, _g62, _path63, _g63, _path64, _g64, _path65, _g65, _path66, _g66, _path67, _g67, _path68, _g68, _path69, _g69, _path70, _g70, _path71, _g71, _path72, _g72, _path73, _g73, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipe2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1989,
    height: 201,
    viewBox: "0 0 1989 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1353.98 228.822V228.694V228.514V228.41V192.931H1314L1314 228.514V228.66V228.734V228.88V231.248V231.37L1314 232.711H1354L1353.98 228.822Z",
    fill: "#DEDC00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1349.37 225.129V225.031V224.893V224.813V197.521H1318.62L1318.62 224.893V225.005V225.062V225.174V226.996V227.09L1318.62 228.121H1349.38L1349.37 225.129Z",
    fill: "url(#paint0_radial_609_2)",
    fillOpacity: 0.7
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1353.98 268.601V268.474V268.293V268.19V232.711H1314L1314 268.293V268.44V268.513V268.66V271.027V271.15L1314 272.49H1354L1353.98 268.601Z",
    fill: "#DEDC00"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1349.37 264.909V264.811V264.672V264.592V237.301H1318.62L1318.62 264.672V264.785V264.841V264.954V266.775V266.869L1318.62 267.9H1349.38L1349.37 264.909Z",
    fill: "url(#paint1_radial_609_2)",
    fillOpacity: 0.7
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1353.98 149.262V149.135V148.955V148.851V113.372H1314L1314 148.955V149.101V149.174V149.321V151.688V151.811L1314 153.151H1354L1353.98 149.262Z",
    fill: "#DEDC00"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1349.37 145.57V145.472V145.333V145.253V117.962H1318.62L1318.62 145.333V145.446V145.502V145.615V147.436V147.53L1318.62 148.562H1349.38L1349.37 145.57Z",
    fill: "url(#paint2_radial_609_2)",
    fillOpacity: 0.7
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1353.98 109.483V109.356V109.175V109.071V73.5922H1314L1314 109.175V109.322V109.395V109.541V111.909V112.031L1314 113.372H1354L1353.98 109.483Z",
    fill: "#DEDC00"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1349.37 105.79V105.693V105.554V105.474V78.1823H1318.62L1318.62 105.554V105.666V105.723V105.835V107.657V107.751L1318.62 108.782H1349.38L1349.37 105.79Z",
    fill: "url(#paint3_radial_609_2)",
    fillOpacity: 0.7
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.98 109.483V109.356V109.175V109.071V73.5922H1354L1354 109.175V109.322V109.395V109.541V111.909V112.031L1354 113.372H1394L1393.98 109.483Z",
    fill: "#DEDC00"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1389.37 105.79V105.693V105.554V105.474V78.1823H1358.62L1358.62 105.554V105.666V105.723V105.835V107.657V107.751L1358.62 108.782H1389.38L1389.37 105.79Z",
    fill: "url(#paint4_radial_609_2)",
    fillOpacity: 0.7
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1433.98 109.483V109.356V109.175V109.071V73.5922H1394L1394 109.175V109.322V109.395V109.541V111.909V112.031L1394 113.372H1434L1433.98 109.483Z",
    fill: "#DEDC00"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1429.37 105.79V105.693V105.554V105.474V78.1823H1398.62L1398.62 105.554V105.666V105.723V105.835V107.657V107.751L1398.62 108.782H1429.38L1429.37 105.79Z",
    fill: "url(#paint5_radial_609_2)",
    fillOpacity: 0.7
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1473.98 109.483V109.356V109.175V109.071V73.5922H1434L1434 109.175V109.322V109.395V109.541V111.909V112.031L1434 113.372H1474L1473.98 109.483Z",
    fill: "#DEDC00"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1469.37 105.79V105.693V105.554V105.474V78.1823H1438.62L1438.62 105.554V105.666V105.723V105.835V107.657V107.751L1438.62 108.782H1469.38L1469.37 105.79Z",
    fill: "url(#paint6_radial_609_2)",
    fillOpacity: 0.7
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1473.98 149.262V149.135V148.955V148.851V113.372H1434L1434 148.955V149.101V149.174V149.321V151.688V151.811L1434 153.151H1474L1473.98 149.262Z",
    fill: "#DEDC00"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1469.37 145.57V145.472V145.333V145.253V117.962H1438.62L1438.62 145.333V145.446V145.502V145.615V147.436V147.53L1438.62 148.562H1469.38L1469.37 145.57Z",
    fill: "url(#paint7_radial_609_2)",
    fillOpacity: 0.7
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1473.98 184.069V183.942V183.762V183.658V148.179H1434L1434 183.762V183.908V183.981V184.128V186.496V186.618L1434 187.958H1474L1473.98 184.069Z",
    fill: "#DEDC00"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1469.37 180.377V180.279V180.14V180.061V152.769H1438.62L1438.62 180.14V180.253V180.309V180.422V182.243V182.337L1438.62 183.369H1469.38L1469.37 180.377Z",
    fill: "url(#paint8_radial_609_2)",
    fillOpacity: 0.7
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1433.98 184.069V183.942V183.762V183.658V148.179H1394L1394 183.762V183.908V183.981V184.128V186.496V186.618L1394 187.958H1434L1433.98 184.069Z",
    fill: "#DEDC00"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1429.37 180.377V180.279V180.14V180.061V152.769H1398.62L1398.62 180.14V180.253V180.309V180.422V182.243V182.337L1398.62 183.369H1429.38L1429.37 180.377Z",
    fill: "url(#paint9_radial_609_2)",
    fillOpacity: 0.7
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.98 184.069V183.942V183.762V183.658V148.179H1354L1354 183.762V183.908V183.981V184.128V186.496V186.618L1354 187.958H1394L1393.98 184.069Z",
    fill: "#DEDC00"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1389.37 180.377V180.279V180.14V180.061V152.769H1358.62L1358.62 180.14V180.253V180.309V180.422V182.243V182.337L1358.62 183.369H1389.38L1389.37 180.377Z",
    fill: "url(#paint10_radial_609_2)",
    fillOpacity: 0.7
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1353.98 189.042V188.915V188.734V188.631V153.152H1314L1314 188.734V188.881V188.954V189.101V191.468V191.591L1314 192.931H1354L1353.98 189.042Z",
    fill: "#DEDC00"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1349.37 185.35V185.252V185.113V185.033V157.742H1318.62L1318.62 185.113V185.226V185.282V185.395V187.216V187.31L1318.62 188.341H1349.38L1349.37 185.35Z",
    fill: "url(#paint11_radial_609_2)",
    fillOpacity: 0.7
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.98 228.822V228.694V228.514V228.41V192.931H1206L1206 228.514V228.66V228.734V228.88V231.248V231.37L1206 232.711H1246L1245.98 228.822Z",
    fill: "#E71E73"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1241.37 225.129V225.031V224.893V224.813V197.521H1210.62L1210.62 224.893V225.005V225.062V225.174V226.996V227.09L1210.62 228.121H1241.38L1241.37 225.129Z",
    fill: "url(#paint12_radial_609_2)",
    fillOpacity: 0.45
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.98 149.262V149.135V148.955V148.851V113.372H1206L1206 148.955V149.101V149.174V149.321V151.688V151.811L1206 153.151H1246L1245.98 149.262Z",
    fill: "#E71E73"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1241.37 145.57V145.472V145.333V145.253V117.962H1210.62L1210.62 145.333V145.446V145.502V145.615V147.436V147.53L1210.62 148.562H1241.38L1241.37 145.57Z",
    fill: "url(#paint13_radial_609_2)",
    fillOpacity: 0.45
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.98 109.483V109.356V109.175V109.071V73.5922H1206L1206 109.175V109.322V109.395V109.541V111.909V112.031L1206 113.372H1246L1245.98 109.483Z",
    fill: "#E71E73"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1241.37 105.79V105.693V105.554V105.474V78.1823H1210.62L1210.62 105.554V105.666V105.723V105.835V107.657V107.751L1210.62 108.782H1241.38L1241.37 105.79Z",
    fill: "url(#paint14_radial_609_2)",
    fillOpacity: 0.45
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.98 189.042V188.915V188.734V188.631V153.152H1206L1206 188.734V188.881V188.954V189.101V191.468V191.591L1206 192.931H1246L1245.98 189.042Z",
    fill: "#E71E73"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1241.37 185.35V185.252V185.113V185.033V157.742H1210.62L1210.62 185.113V185.226V185.282V185.395V187.216V187.31L1210.62 188.341H1241.38L1241.37 185.35Z",
    fill: "url(#paint15_radial_609_2)",
    fillOpacity: 0.45
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.98 268.601V268.474V268.293V268.19V232.711H1206L1206 268.293V268.44V268.513V268.66V271.027V271.15L1206 272.49H1246L1245.98 268.601Z",
    fill: "#E71E73"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1241.37 264.909V264.811V264.672V264.592V237.301H1210.62L1210.62 264.672V264.785V264.841V264.954V266.775V266.869L1210.62 267.9H1241.38L1241.37 264.909Z",
    fill: "url(#paint16_radial_609_2)",
    fillOpacity: 0.45
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M339.985 228.822V228.694V228.514V228.41V192.931H300L300 228.514V228.66V228.734V228.88V231.248V231.37L300 232.711H340L339.985 228.822Z",
    fill: "#E71E73"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.373 225.129V225.031V224.893V224.813V197.521H304.615L304.615 224.893V225.005V225.062V225.174V226.996V227.09L304.615 228.121H335.385L335.373 225.129Z",
    fill: "url(#paint17_radial_609_2)",
    fillOpacity: 0.45
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M339.985 149.262V149.135V148.955V148.851V113.372H300L300 148.955V149.101V149.174V149.321V151.688V151.811L300 153.151H340L339.985 149.262Z",
    fill: "#E71E73"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.373 145.57V145.472V145.333V145.253V117.962H304.615L304.615 145.333V145.446V145.502V145.615V147.436V147.53L304.615 148.562H335.385L335.373 145.57Z",
    fill: "url(#paint18_radial_609_2)",
    fillOpacity: 0.45
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M339.985 109.483V109.356V109.175V109.071V73.5922H300L300 109.175V109.322V109.395V109.541V111.909V112.031L300 113.372H340L339.985 109.483Z",
    fill: "#E71E73"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.373 105.79V105.693V105.554V105.474V78.1823H304.615L304.615 105.554V105.666V105.723V105.835V107.657V107.751L304.615 108.782H335.385L335.373 105.79Z",
    fill: "url(#paint19_radial_609_2)",
    fillOpacity: 0.45
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M339.985 189.042V188.915V188.734V188.631V153.152H300L300 188.734V188.881V188.954V189.101V191.468V191.591L300 192.931H340L339.985 189.042Z",
    fill: "#E71E73"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.373 185.35V185.252V185.113V185.033V157.742H304.615L304.615 185.113V185.226V185.282V185.395V187.216V187.31L304.615 188.341H335.385L335.373 185.35Z",
    fill: "url(#paint20_radial_609_2)",
    fillOpacity: 0.45
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M339.985 268.601V268.474V268.293V268.19V232.711H300L300 268.293V268.44V268.513V268.66V271.027V271.15L300 272.49H340L339.985 268.601Z",
    fill: "#E71E73"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.373 264.909V264.811V264.672V264.592V237.301H304.615L304.615 264.672V264.785V264.841V264.954V266.775V266.869L304.615 267.9H335.385L335.373 264.909Z",
    fill: "url(#paint21_radial_609_2)",
    fillOpacity: 0.45
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M379.985 268.601V268.474V268.293V268.19V232.711H340L340 268.293V268.44V268.513V268.66V271.027V271.15L340 272.49H380L379.985 268.601Z",
    fill: "#E71E73"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.373 264.909V264.811V264.672V264.592V237.301H344.615L344.615 264.672V264.785V264.841V264.954V266.775V266.869L344.615 267.9H375.385L375.373 264.909Z",
    fill: "url(#paint22_radial_609_2)",
    fillOpacity: 0.45
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M419.985 268.601V268.474V268.293V268.19V232.711H380L380 268.293V268.44V268.513V268.66V271.027V271.15L380 272.49H420L419.985 268.601Z",
    fill: "#E71E73"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.373 264.909V264.811V264.672V264.592V237.301H384.615L384.615 264.672V264.785V264.841V264.954V266.775V266.869L384.615 267.9H415.385L415.373 264.909Z",
    fill: "url(#paint23_radial_609_2)",
    fillOpacity: 0.45
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M473.792 71.1357L473.702 71.0458L473.574 70.9182L473.5 70.8448L448.273 45.7573L420 73.875L445.3 99.0359L445.404 99.1394L445.457 99.1912L445.561 99.2948L447.244 100.969L447.331 101.056L448.284 102.003L476.569 73.875L473.792 71.1357Z",
    fill: "#662383"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.906 71.7678L467.836 71.6987L467.738 71.6005L467.681 71.5441L448.276 52.246L426.527 73.875L445.989 93.2295L446.069 93.3091L446.109 93.349L446.189 93.4286L447.484 94.7165L447.551 94.783L448.284 95.5122L470.041 73.875L467.906 71.7678Z",
    fill: "url(#paint24_radial_609_2)",
    fillOpacity: 0.2
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M567.089 192.946H566.961H566.78H566.676H531V232.711L566.78 232.711H566.927H567.001H567.148H569.529H569.652L571 232.711V192.931L567.089 192.946Z",
    fill: "#94C11F"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.376 197.533H563.278H563.138H563.058H535.615V228.121L563.138 228.121H563.252H563.308H563.422H565.253H565.348L566.385 228.121V197.521L563.376 197.533Z",
    fill: "url(#paint25_radial_609_2)",
    fillOpacity: 0.55
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M567.089 232.726H566.961H566.78H566.676H531V272.49L566.78 272.49H566.927H567.001H567.148H569.529H569.652L571 272.49V232.711L567.089 232.726Z",
    fill: "#94C11F"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.376 237.312H563.278H563.138H563.058H535.615V267.9L563.138 267.9H563.252H563.308H563.422H565.253H565.348L566.385 267.9V237.301L563.376 237.312Z",
    fill: "url(#paint26_radial_609_2)",
    fillOpacity: 0.55
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M607.089 232.726H606.961H606.78H606.676H571V272.49L606.78 272.49H606.927H607.001H607.148H609.529H609.652L611 272.49V232.711L607.089 232.726Z",
    fill: "#94C11F"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.376 237.312H603.278H603.138H603.058H575.615V267.9L603.138 267.9H603.252H603.308H603.422H605.253H605.348L606.385 267.9V237.301L603.376 237.312Z",
    fill: "url(#paint27_radial_609_2)",
    fillOpacity: 0.55
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M647.089 232.726H646.961H646.78H646.676H611V272.49L646.78 272.49H646.927H647.001H647.148H649.529H649.652L651 272.49V232.711L647.089 232.726Z",
    fill: "#94C11F"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.376 237.312H643.278H643.138H643.058H615.615V267.9L643.138 267.9H643.252H643.308H643.422H645.253H645.348L646.385 267.9V237.301L643.376 237.312Z",
    fill: "url(#paint28_radial_609_2)",
    fillOpacity: 0.55
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M567.089 153.167H566.961H566.78H566.676H531V192.931L566.78 192.931H566.927H567.001H567.148H569.529H569.652L571 192.931V153.151L567.089 153.167Z",
    fill: "#94C11F"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.376 157.753H563.278H563.138H563.058H535.615V188.341L563.138 188.341H563.252H563.308H563.422H565.253H565.348L566.385 188.341V157.741L563.376 157.753Z",
    fill: "url(#paint29_radial_609_2)",
    fillOpacity: 0.55
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M567.089 113.387H566.961H566.78H566.676H531V153.151L566.78 153.151H566.927H567.001H567.148H569.529H569.652L571 153.151V113.372L567.089 113.387Z",
    fill: "#94C11F"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.376 117.974H563.278H563.138H563.058H535.615V148.562L563.138 148.562H563.252H563.308H563.422H565.253H565.348L566.385 148.561V117.962L563.376 117.974Z",
    fill: "url(#paint30_radial_609_2)",
    fillOpacity: 0.55
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M567.089 73.6074H566.961H566.78H566.676H531V113.372L566.78 113.372H566.927H567.001H567.148H569.529H569.652L571 113.372V73.5922L567.089 73.6074Z",
    fill: "#94C11F"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.376 78.194H563.278H563.138H563.058H535.615V108.782L563.138 108.782H563.252H563.308H563.422H565.253H565.348L566.385 108.782V78.1823L563.376 78.194Z",
    fill: "url(#paint31_radial_609_2)",
    fillOpacity: 0.55
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M607.089 73.6074H606.961H606.78H606.676H571V113.372L606.78 113.372H606.927H607.001H607.148H609.529H609.652L611 113.372V73.5922L607.089 73.6074Z",
    fill: "#94C11F"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.376 78.194H603.278H603.138H603.058H575.615V108.782L603.138 108.782H603.252H603.308H603.422H605.253H605.348L606.385 108.782V78.1823L603.376 78.194Z",
    fill: "url(#paint32_radial_609_2)",
    fillOpacity: 0.55
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M647.089 73.6074H646.961H646.78H646.676H611V113.372L646.78 113.372H646.927H647.001H647.148H649.529H649.652L651 113.372V73.5922L647.089 73.6074Z",
    fill: "#94C11F"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.376 78.194H643.278H643.138H643.058H615.615V108.782L643.138 108.782H643.252H643.308H643.422H645.253H645.348L646.385 108.782V78.1823L643.376 78.194Z",
    fill: "url(#paint33_radial_609_2)",
    fillOpacity: 0.55
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M607.089 153.167H606.961H606.78H606.676H571V192.931L606.78 192.931H606.927H607.001H607.148H609.529H609.652L611 192.931V153.151L607.089 153.167Z",
    fill: "#94C11F"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.376 157.753H603.278H603.138H603.058H575.615V188.341L603.138 188.341H603.252H603.308H603.422H605.253H605.348L606.385 188.341V157.741L603.376 157.753Z",
    fill: "url(#paint34_radial_609_2)",
    fillOpacity: 0.55
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1578.09 195.93H1577.96H1577.78H1577.68H1542V235.694L1577.78 235.694H1577.93H1578H1578.15H1580.53H1580.65L1582 235.694V195.915L1578.09 195.93Z",
    fill: "#94C11F"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1574.38 200.517H1574.28H1574.14H1574.06H1546.62V231.104L1574.14 231.104H1574.25H1574.31H1574.42H1576.25H1576.35L1577.38 231.104V200.505L1574.38 200.517Z",
    fill: "url(#paint35_radial_609_2)",
    fillOpacity: 0.55
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1578.09 235.71H1577.96H1577.78H1577.68H1542V275.474L1577.78 275.474H1577.93H1578H1578.15H1580.53H1580.65L1582 275.474V235.694L1578.09 235.71Z",
    fill: "#94C11F"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1574.38 240.296H1574.28H1574.14H1574.06H1546.62V270.884L1574.14 270.884H1574.25H1574.31H1574.42H1576.25H1576.35L1577.38 270.884V240.284L1574.38 240.296Z",
    fill: "url(#paint36_radial_609_2)",
    fillOpacity: 0.55
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1618.09 235.71H1617.96H1617.78H1617.68H1582V275.474L1617.78 275.474H1617.93H1618H1618.15H1620.53H1620.65L1622 275.474V235.694L1618.09 235.71Z",
    fill: "#94C11F"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1614.38 240.296H1614.28H1614.14H1614.06H1586.62V270.884L1614.14 270.884H1614.25H1614.31H1614.42H1616.25H1616.35L1617.38 270.884V240.284L1614.38 240.296Z",
    fill: "url(#paint37_radial_609_2)",
    fillOpacity: 0.55
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1658.09 235.71H1657.96H1657.78H1657.68H1622V275.474L1657.78 275.474H1657.93H1658H1658.15H1660.53H1660.65L1662 275.474V235.694L1658.09 235.71Z",
    fill: "#94C11F"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1654.38 240.296H1654.28H1654.14H1654.06H1626.62V270.884L1654.14 270.884H1654.25H1654.31H1654.42H1656.25H1656.35L1657.38 270.884V240.284L1654.38 240.296Z",
    fill: "url(#paint38_radial_609_2)",
    fillOpacity: 0.55
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1578.09 156.15H1577.96H1577.78H1577.68H1542V195.915L1577.78 195.915H1577.93H1578H1578.15H1580.53H1580.65L1582 195.915V156.135L1578.09 156.15Z",
    fill: "#94C11F"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1574.38 160.737H1574.28H1574.14H1574.06H1546.62V191.325L1574.14 191.325H1574.25H1574.31H1574.42H1576.25H1576.35L1577.38 191.325V160.725L1574.38 160.737Z",
    fill: "url(#paint39_radial_609_2)",
    fillOpacity: 0.55
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1578.09 116.371H1577.96H1577.78H1577.68H1542V156.135L1577.78 156.135H1577.93H1578H1578.15H1580.53H1580.65L1582 156.135V116.355L1578.09 116.371Z",
    fill: "#94C11F"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1574.38 120.957H1574.28H1574.14H1574.06H1546.62V151.545L1574.14 151.545H1574.25H1574.31H1574.42H1576.25H1576.35L1577.38 151.545V120.945L1574.38 120.957Z",
    fill: "url(#paint40_radial_609_2)",
    fillOpacity: 0.55
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1578.09 76.5911H1577.96H1577.78H1577.68H1542V116.355L1577.78 116.355H1577.93H1578H1578.15H1580.53H1580.65L1582 116.355V76.5759L1578.09 76.5911Z",
    fill: "#94C11F"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1574.38 81.1776H1574.28H1574.14H1574.06H1546.62V111.766L1574.14 111.766H1574.25H1574.31H1574.42H1576.25H1576.35L1577.38 111.766V81.1659L1574.38 81.1776Z",
    fill: "url(#paint41_radial_609_2)",
    fillOpacity: 0.55
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1618.09 76.5911H1617.96H1617.78H1617.68H1582V116.355L1617.78 116.355H1617.93H1618H1618.15H1620.53H1620.65L1622 116.355V76.5759L1618.09 76.5911Z",
    fill: "#94C11F"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1614.38 81.1776H1614.28H1614.14H1614.06H1586.62V111.766L1614.14 111.766H1614.25H1614.31H1614.42H1616.25H1616.35L1617.38 111.766V81.1659L1614.38 81.1776Z",
    fill: "url(#paint42_radial_609_2)",
    fillOpacity: 0.55
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1658.09 76.5911H1657.96H1657.78H1657.68H1622V116.355L1657.78 116.355H1657.93H1658H1658.15H1660.53H1660.65L1662 116.355V76.5759L1658.09 76.5911Z",
    fill: "#94C11F"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1654.38 81.1776H1654.28H1654.14H1654.06H1626.62V111.766L1654.14 111.766H1654.25H1654.31H1654.42H1656.25H1656.35L1657.38 111.766V81.1659L1654.38 81.1776Z",
    fill: "url(#paint43_radial_609_2)",
    fillOpacity: 0.55
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1618.09 156.15H1617.96H1617.78H1617.68H1582V195.915L1617.78 195.915H1617.93H1618H1618.15H1620.53H1620.65L1622 195.915V156.135L1618.09 156.15Z",
    fill: "#94C11F"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1614.38 160.737H1614.28H1614.14H1614.06H1586.62V191.325L1614.14 191.325H1614.25H1614.31H1614.42H1616.25H1616.35L1617.38 191.325V160.725L1614.38 160.737Z",
    fill: "url(#paint44_radial_609_2)",
    fillOpacity: 0.55
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M878.985 228.822V228.694V228.514V228.41V192.931H839L839 228.514V228.66V228.734V228.88V231.248V231.37L839 232.711H879L878.985 228.822Z",
    fill: "#DA8300"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.373 225.129V225.031V224.893V224.813V197.521H843.615L843.615 224.893V225.005V225.062V225.174V226.996V227.09L843.615 228.121H874.385L874.373 225.129Z",
    fill: "url(#paint45_radial_609_2)",
    fillOpacity: 0.6
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M758.985 149.262V149.135V148.955V148.851V113.372H719L719 148.955V149.101V149.174V149.321V151.688V151.811L719 153.151H759L758.985 149.262Z",
    fill: "#DA8300"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.373 145.57V145.472V145.333V145.253V117.962H723.615L723.615 145.333V145.446V145.502V145.615V147.436V147.53L723.615 148.562H754.385L754.373 145.57Z",
    fill: "url(#paint46_radial_609_2)",
    fillOpacity: 0.6
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M878.985 149.262V149.135V148.955V148.851V113.372H839L839 148.955V149.101V149.174V149.321V151.688V151.811L839 153.151H879L878.985 149.262Z",
    fill: "#DA8300"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.373 145.57V145.472V145.333V145.253V117.962H843.615L843.615 145.333V145.446V145.502V145.615V147.436V147.53L843.615 148.562H874.385L874.373 145.57Z",
    fill: "url(#paint47_radial_609_2)",
    fillOpacity: 0.6
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M758.985 189.042V188.915V188.734V188.631V153.152H719L719 188.734V188.881V188.954V189.101V191.468V191.591L719 192.931H759L758.985 189.042Z",
    fill: "#DA8300"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.373 185.35V185.252V185.113V185.033V157.742H723.615L723.615 185.113V185.226V185.282V185.395V187.216V187.31L723.615 188.341H754.385L754.373 185.35Z",
    fill: "url(#paint48_radial_609_2)",
    fillOpacity: 0.6
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M878.985 189.042V188.915V188.734V188.631V153.152H839L839 188.734V188.881V188.954V189.101V191.468V191.591L839 192.931H879L878.985 189.042Z",
    fill: "#DA8300"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.373 185.35V185.252V185.113V185.033V157.742H843.615L843.615 185.113V185.226V185.282V185.395V187.216V187.31L843.615 188.341H874.385L874.373 185.35Z",
    fill: "url(#paint49_radial_609_2)",
    fillOpacity: 0.6
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M758.985 109.483V109.356V109.175V109.071V73.5922H719L719 109.175V109.322V109.395V109.541V111.909V112.031L719 113.372H759L758.985 109.483Z",
    fill: "#DA8300"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.373 105.79V105.693V105.554V105.474V78.1823H723.615L723.615 105.554V105.666V105.723V105.835V107.657V107.751L723.615 108.782H754.385L754.373 105.79Z",
    fill: "url(#paint50_radial_609_2)",
    fillOpacity: 0.6
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M798.985 109.483V109.356V109.175V109.071V73.5922H759L759 109.175V109.322V109.395V109.541V111.909V112.031L759 113.372H799L798.985 109.483Z",
    fill: "#DA8300"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M794.373 105.79V105.693V105.554V105.474V78.1823H763.615L763.615 105.554V105.666V105.723V105.835V107.657V107.751L763.615 108.782H794.385L794.373 105.79Z",
    fill: "url(#paint51_radial_609_2)",
    fillOpacity: 0.6
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M838.985 109.483V109.356V109.175V109.071V73.5922H799L799 109.175V109.322V109.395V109.541V111.909V112.031L799 113.372H839L838.985 109.483Z",
    fill: "#DA8300"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M834.373 105.79V105.693V105.554V105.474V78.1823H803.615L803.615 105.554V105.666V105.723V105.835V107.657V107.751L803.615 108.782H834.385L834.373 105.79Z",
    fill: "url(#paint52_radial_609_2)",
    fillOpacity: 0.6
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M798.985 268.601V268.474V268.293V268.19V232.711H759L759 268.293V268.44V268.513V268.66V271.027V271.15L759 272.49H799L798.985 268.601Z",
    fill: "#DA8300"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M794.373 264.909V264.811V264.672V264.592V237.301H763.615L763.615 264.672V264.785V264.841V264.954V266.775V266.869L763.615 267.9H794.385L794.373 264.909Z",
    fill: "url(#paint53_radial_609_2)",
    fillOpacity: 0.6
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M838.985 268.601V268.474V268.293V268.19V232.711H799L799 268.293V268.44V268.513V268.66V271.027V271.15L799 272.49H839L838.985 268.601Z",
    fill: "#DA8300"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M834.373 264.909V264.811V264.672V264.592V237.301H803.615L803.615 264.672V264.785V264.841V264.954V266.775V266.869L803.615 267.9H834.385L834.373 264.909Z",
    fill: "url(#paint54_radial_609_2)",
    fillOpacity: 0.6
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M878.985 268.601V268.474V268.293V268.19V232.711H839L839 268.293V268.44V268.513V268.66V271.027V271.15L839 272.49H879L878.985 268.601Z",
    fill: "#DA8300"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.373 264.909V264.811V264.672V264.592V237.301H843.615L843.615 264.672V264.785V264.841V264.954V266.775V266.869L843.615 267.9H874.385L874.373 264.909Z",
    fill: "url(#paint55_radial_609_2)",
    fillOpacity: 0.6
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M878.792 244.177L878.702 244.087L878.574 243.96L878.5 243.886L853.273 218.799L825 246.917L850.3 272.077L850.404 272.181L850.457 272.233L850.561 272.336L852.244 274.01L852.331 274.097L853.284 275.045L881.569 246.916L878.792 244.177Z",
    fill: "#DA8300"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.906 251.77L878.836 251.701L878.738 251.603L878.681 251.547L859.276 232.249L837.527 253.878L856.989 273.232L857.069 273.312L857.109 273.352L857.189 273.431L858.484 274.719L858.551 274.786L859.284 275.515L881.041 253.878L878.906 251.77Z",
    fill: "url(#paint56_radial_609_2)",
    fillOpacity: 0.6
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M906.792 272.023L906.702 271.933L906.574 271.805L906.5 271.732L881.273 246.644L853 274.762L878.3 299.923L878.404 300.026L878.457 300.078L878.561 300.182L880.244 301.856L880.331 301.942L881.284 302.89L909.569 274.762L906.792 272.023Z",
    fill: "#DA8300"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter57_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900.906 272.655L900.836 272.586L900.738 272.487L900.681 272.431L881.276 253.133L859.527 274.762L878.989 294.116L879.069 294.196L879.109 294.236L879.189 294.316L880.484 295.603L880.551 295.67L881.284 296.399L903.041 274.762L900.906 272.655Z",
    fill: "url(#paint57_radial_609_2)",
    fillOpacity: 0.6
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M878.985 109.483V109.356V109.175V109.071V73.5922H839L839 109.175V109.322V109.395V109.541V111.909V112.031L839 113.372H879L878.985 109.483Z",
    fill: "#DA8300"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.373 105.79V105.693V105.554V105.474V78.1823H843.615L843.615 105.554V105.666V105.723V105.835V107.657V107.751L843.615 108.782H874.385L874.373 105.79Z",
    fill: "url(#paint58_radial_609_2)",
    fillOpacity: 0.6
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M758.985 268.601V268.474V268.293V268.19V232.711H719L719 268.293V268.44V268.513V268.66V271.027V271.15L719 272.49H759L758.985 268.601Z",
    fill: "#DA8300"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter59_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.373 264.909V264.811V264.672V264.592V237.301H723.615L723.615 264.672V264.785V264.841V264.954V266.775V266.869L723.615 267.9H754.385L754.373 264.909Z",
    fill: "url(#paint59_radial_609_2)",
    fillOpacity: 0.6
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M758.985 228.822V228.694V228.514V228.41V192.931H719L719 228.514V228.66V228.734V228.88V231.248V231.37L719 232.711H759L758.985 228.822Z",
    fill: "#DA8300"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter60_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.373 225.129V225.031V224.893V224.813V197.521H723.615L723.615 224.893V225.005V225.062V225.174V226.996V227.09L723.615 228.121H754.385L754.373 225.129Z",
    fill: "url(#paint60_radial_609_2)",
    fillOpacity: 0.6
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.09 230.737H1053.96H1053.78H1053.68H1018V270.501L1053.78 270.501H1053.93H1054H1054.15H1056.53H1056.65L1058 270.501V230.722L1054.09 230.737Z",
    fill: "#14ADC6"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter61_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1050.38 235.323H1050.28H1050.14H1050.06H1022.62V265.911L1050.14 265.911H1050.25H1050.31H1050.42H1052.25H1052.35L1053.38 265.911V235.312L1050.38 235.323Z",
    fill: "url(#paint61_radial_609_2)",
    fillOpacity: 0.55
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.09 151.178H1013.96H1013.78H1013.68H978V190.942L1013.78 190.942H1013.93H1014H1014.15H1016.53H1016.65L1018 190.942V151.163L1014.09 151.178Z",
    fill: "#14ADC6"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter62_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1010.38 155.764H1010.28H1010.14H1010.06H982.616V186.352L1010.14 186.352H1010.25H1010.31H1010.42H1012.25H1012.35L1013.38 186.352V155.752L1010.38 155.764Z",
    fill: "url(#paint62_radial_609_2)",
    fillOpacity: 0.55
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.09 190.958H1013.96H1013.78H1013.68H978V230.722L1013.78 230.722H1013.93H1014H1014.15H1016.53H1016.65L1018 230.722V190.942L1014.09 190.958Z",
    fill: "#14ADC6"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter63_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1010.38 195.544H1010.28H1010.14H1010.06H982.616V226.132L1010.14 226.132H1010.25H1010.31H1010.42H1012.25H1012.35L1013.38 226.132V195.532L1010.38 195.544Z",
    fill: "url(#paint63_radial_609_2)",
    fillOpacity: 0.55
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.09 230.737H1013.96H1013.78H1013.68H978V270.501L1013.78 270.501H1013.93H1014H1014.15H1016.53H1016.65L1018 270.501V230.722L1014.09 230.737Z",
    fill: "#14ADC6"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter64_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1010.38 235.323H1010.28H1010.14H1010.06H982.616V265.911L1010.14 265.911H1010.25H1010.31H1010.42H1012.25H1012.35L1013.38 265.911V235.312L1010.38 235.323Z",
    fill: "url(#paint64_radial_609_2)",
    fillOpacity: 0.55
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.09 230.737H1093.96H1093.78H1093.68H1058V270.501L1093.78 270.501H1093.93H1094H1094.15H1096.53H1096.65L1098 270.501V230.722L1094.09 230.737Z",
    fill: "#14ADC6"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter65_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1090.38 235.323H1090.28H1090.14H1090.06H1062.62V265.911L1090.14 265.911H1090.25H1090.31H1090.42H1092.25H1092.35L1093.38 265.911V235.312L1090.38 235.323Z",
    fill: "url(#paint65_radial_609_2)",
    fillOpacity: 0.55
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.09 190.958H1133.96H1133.78H1133.68H1098V230.722L1133.78 230.722H1133.93H1134H1134.15H1136.53H1136.65L1138 230.722V190.942L1134.09 190.958Z",
    fill: "#14ADC6"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter66_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1130.38 195.544H1130.28H1130.14H1130.06H1102.62V226.132L1130.14 226.132H1130.25H1130.31H1130.42H1132.25H1132.35L1133.38 226.132V195.532L1130.38 195.544Z",
    fill: "url(#paint66_radial_609_2)",
    fillOpacity: 0.55
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.09 151.178H1133.96H1133.78H1133.68H1098V190.942L1133.78 190.942H1133.93H1134H1134.15H1136.53H1136.65L1138 190.942V151.163L1134.09 151.178Z",
    fill: "#14ADC6"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1130.38 155.764H1130.28H1130.14H1130.06H1102.62V186.352L1130.14 186.352H1130.25H1130.31H1130.42H1132.25H1132.35L1133.38 186.352V155.752L1130.38 155.764Z",
    fill: "url(#paint67_radial_609_2)",
    fillOpacity: 0.55
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.09 111.398H1133.96H1133.78H1133.68H1098V151.163L1133.78 151.163H1133.93H1134H1134.15H1136.53H1136.65L1138 151.163V111.383L1134.09 111.398Z",
    fill: "#14ADC6"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter68_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1130.38 115.985H1130.28H1130.14H1130.06H1102.62V146.573L1130.14 146.572H1130.25H1130.31H1130.42H1132.25H1132.35L1133.38 146.572V115.973L1130.38 115.985Z",
    fill: "url(#paint68_radial_609_2)",
    fillOpacity: 0.55
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.09 71.6187H1133.96H1133.78H1133.68H1098V111.383L1133.78 111.383H1133.93H1134H1134.15H1136.53H1136.65L1138 111.383V71.6034L1134.09 71.6187Z",
    fill: "#14ADC6"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter69_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1130.38 76.205H1130.28H1130.14H1130.06H1102.62V106.793L1130.14 106.793H1130.25H1130.31H1130.42H1132.25H1132.35L1133.38 106.793V76.1933L1130.38 76.205Z",
    fill: "url(#paint69_radial_609_2)",
    fillOpacity: 0.55
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.09 230.737H1133.96H1133.78H1133.68H1098V270.501L1133.78 270.501H1133.93H1134H1134.15H1136.53H1136.65L1138 270.501V230.722L1134.09 230.737Z",
    fill: "#14ADC6"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter70_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1130.38 235.323H1130.28H1130.14H1130.06H1102.62V265.911L1130.14 265.911H1130.25H1130.31H1130.42H1132.25H1132.35L1133.38 265.911V235.312L1130.38 235.323Z",
    fill: "url(#paint70_radial_609_2)",
    fillOpacity: 0.55
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.09 111.398H1013.96H1013.78H1013.68H978V151.163L1013.78 151.163H1013.93H1014H1014.15H1016.53H1016.65L1018 151.163V111.383L1014.09 111.398Z",
    fill: "#14ADC6"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter71_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1010.38 115.985H1010.28H1010.14H1010.06H982.616V146.573L1010.14 146.572H1010.25H1010.31H1010.42H1012.25H1012.35L1013.38 146.572V115.973L1010.38 115.985Z",
    fill: "url(#paint71_radial_609_2)",
    fillOpacity: 0.55
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.09 71.6187H1013.96H1013.78H1013.68H978V111.383L1013.78 111.383H1013.93H1014H1014.15H1016.53H1016.65L1018 111.383V71.6034L1014.09 71.6187Z",
    fill: "#14ADC6"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter72_f_609_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1010.38 76.205H1010.28H1010.14H1010.06H982.616V106.793L1010.14 106.793H1010.25H1010.31H1010.42H1012.25H1012.35L1013.38 106.793V76.1933L1010.38 76.205Z",
    fill: "url(#paint72_radial_609_2)",
    fillOpacity: 0.55
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_609_2",
    x: 1312.62,
    y: 191.521,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_609_2",
    x: 1312.62,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_609_2",
    x: 1312.62,
    y: 111.962,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_609_2",
    x: 1312.62,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_609_2",
    x: 1352.62,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_609_2",
    x: 1392.62,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_609_2",
    x: 1432.62,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_609_2",
    x: 1432.62,
    y: 111.962,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_609_2",
    x: 1432.62,
    y: 146.769,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_609_2",
    x: 1392.62,
    y: 146.769,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_609_2",
    x: 1352.62,
    y: 146.769,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_609_2",
    x: 1312.62,
    y: 151.742,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_609_2",
    x: 1204.62,
    y: 191.521,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_609_2",
    x: 1204.62,
    y: 111.962,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_609_2",
    x: 1204.62,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_609_2",
    x: 1204.62,
    y: 151.742,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_609_2",
    x: 1204.62,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_609_2",
    x: 298.615,
    y: 191.521,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_609_2",
    x: 298.615,
    y: 111.962,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_609_2",
    x: 298.615,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_609_2",
    x: 298.615,
    y: 151.742,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_609_2",
    x: 298.615,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_609_2",
    x: 338.615,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_609_2",
    x: 378.615,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_609_2",
    x: 420.527,
    y: 46.2461,
    width: 55.5143,
    height: 55.2661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_609_2",
    x: 529.615,
    y: 191.521,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_609_2",
    x: 529.615,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_609_2",
    x: 569.615,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_609_2",
    x: 609.615,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_609_2",
    x: 529.615,
    y: 151.741,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_609_2",
    x: 529.615,
    y: 111.962,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_609_2",
    x: 529.615,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_609_2",
    x: 569.615,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_f_609_2",
    x: 609.615,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_f_609_2",
    x: 569.615,
    y: 151.741,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_f_609_2",
    x: 1540.62,
    y: 194.505,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_f_609_2",
    x: 1540.62,
    y: 234.284,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_f_609_2",
    x: 1580.62,
    y: 234.284,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_f_609_2",
    x: 1620.62,
    y: 234.284,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_f_609_2",
    x: 1540.62,
    y: 154.725,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_f_609_2",
    x: 1540.62,
    y: 114.946,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_f_609_2",
    x: 1540.62,
    y: 75.166,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_f_609_2",
    x: 1580.62,
    y: 75.166,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_f_609_2",
    x: 1620.62,
    y: 75.166,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_f_609_2",
    x: 1580.62,
    y: 154.725,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_f_609_2",
    x: 837.615,
    y: 191.521,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_f_609_2",
    x: 717.615,
    y: 111.962,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_f_609_2",
    x: 837.615,
    y: 111.962,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_f_609_2",
    x: 717.615,
    y: 151.742,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_f_609_2",
    x: 837.615,
    y: 151.742,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_f_609_2",
    x: 717.615,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_f_609_2",
    x: 757.615,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_f_609_2",
    x: 797.615,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_f_609_2",
    x: 757.615,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_f_609_2",
    x: 797.615,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_f_609_2",
    x: 837.615,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_f_609_2",
    x: 831.527,
    y: 226.249,
    width: 55.5143,
    height: 55.2661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_f_609_2",
    x: 853.527,
    y: 247.133,
    width: 55.5143,
    height: 55.2661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_f_609_2",
    x: 837.615,
    y: 72.1824,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_f_609_2",
    x: 717.615,
    y: 231.301,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter60_f_609_2",
    x: 717.615,
    y: 191.521,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter61_f_609_2",
    x: 1016.62,
    y: 229.312,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter62_f_609_2",
    x: 976.616,
    y: 149.752,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter63_f_609_2",
    x: 976.616,
    y: 189.532,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter64_f_609_2",
    x: 976.616,
    y: 229.312,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter65_f_609_2",
    x: 1056.62,
    y: 229.312,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter66_f_609_2",
    x: 1096.62,
    y: 189.532,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter67_f_609_2",
    x: 1096.62,
    y: 149.752,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter68_f_609_2",
    x: 1096.62,
    y: 109.973,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter69_f_609_2",
    x: 1096.62,
    y: 70.1934,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter70_f_609_2",
    x: 1096.62,
    y: 229.312,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter71_f_609_2",
    x: 976.616,
    y: 109.973,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter72_f_609_2",
    x: 976.616,
    y: 70.1934,
    width: 42.7692,
    height: 42.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_609_2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1334.92 212.974) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1334.92 252.754) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1334.92 133.415) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1334.92 93.6351) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1374.92 93.6351) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1414.92 93.6351) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1454.92 93.6351) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1454.92 133.415) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1454.92 168.222) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1414.92 168.222) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1374.92 168.222) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1334.92 173.194) rotate(-152.221) scale(38.0809 35.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1226.92 212.974) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1226.92 133.415) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1226.92 93.6351) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1226.92 173.194) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1226.92 252.754) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320.923 212.974) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320.923 133.415) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320.923 93.6351) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320.923 173.194) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320.923 252.754) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(360.923 252.754) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(400.923 252.754) rotate(-150.739) scale(25.0413 23.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(449.046 73.334) rotate(157.702) scale(22.8102 21.1833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(551.154 211.903) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(551.154 251.683) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(591.154 251.683) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(631.154 251.683) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(551.154 172.123) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(551.154 132.344) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(551.154 92.5641) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(591.154 92.5641) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(631.154 92.5641) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(591.154 172.123) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1562.15 214.887) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1562.15 254.666) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1602.15 254.666) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1642.15 254.666) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1562.15 175.107) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1562.15 135.327) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1562.15 95.5478) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1602.15 95.5478) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1642.15 95.5478) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1602.15 175.107) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(859.923 212.974) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(739.923 133.415) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(859.923 133.415) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(739.923 173.194) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(859.923 173.194) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(739.923 93.6351) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(779.923 93.6351) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(819.923 93.6351) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(779.923 252.754) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(819.923 252.754) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(859.923 252.754) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(860.046 253.337) rotate(157.825) scale(28.6638 26.6189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(882.046 274.221) rotate(157.825) scale(28.6638 26.6189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(859.923 93.6351) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(739.923 252.754) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(739.923 212.974) rotate(-157.398) scale(28.6629 26.6197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1038.15 249.694) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(998.154 170.134) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(998.154 209.914) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(998.154 249.694) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1078.15 249.694) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1118.15 209.914) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1118.15 170.134) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1118.15 130.355) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1118.15 90.5751) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1118.15 249.694) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(998.154 130.355) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_609_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(998.154 90.5751) rotate(112.827) scale(28.552 26.7231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipe2);
export default __webpack_public_path__ + "static/media/equipe2.e6890e809f30e7d05dbc6b670bfec15f.svg";
export { ForwardRef as ReactComponent };